"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function MobileCheck16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "mobile-check-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M8,0 C9.65685425,0 11,1.34314575 11,3 L11,3 L9,3 C9,2.44771525 8.55228475,2 8,2 L8,2 L4,2 C3.44771525,2 3,2.44771525 3,3 L3,3 L3,13 C3,13.5522847 3.44771525,14 4,14 L4,14 L8,14 C8.55228475,14 9,13.5522847 9,13 L9,13 L9,9.12646484 L11,9.12646484 L11,13 C11,14.6568542 9.65685425,16 8,16 L8,16 L4,16 C2.34314575,16 1,14.6568542 1,13 L1,13 L1,3 C1,1.34314575 2.34314575,0 4,0 L4,0 Z M6,11 C6.55228475,11 7,11.4477153 7,12 C7,12.5522847 6.55228475,13 6,13 C5.44771525,13 5,12.5522847 5,12 C5,11.4477153 5.44771525,11 6,11 Z M14.0510672,1.58670876 L15.4132912,3.0510672 L9.70009517,8.36578582 L6.58670876,5.46954831 L7.9489328,4.00518987 L9.70009517,5.63421418 L14.0510672,1.58670876 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" })));
}
function MobileCheck16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(MobileCheck16Svg, Object.assign({}, svgProps)));
}
exports.default = MobileCheck16;
//# sourceMappingURL=MobileCheck16.js.map